module.exports = __webpack_public_path__ + "img/paypal.8721c996.webp";